import React, { useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import moment from 'moment'
import CardWidget, { Colors } from '../../../../components/CardWidget'
import CardWidgetSkeleton from '../../../../components/skeletons/CardWidgetSkeleton'
import { formatCurrency } from '../../../../utils/Helpers'
// import { STATUS_DELIVERED, STATUS_DELIVERING, STATUS_AVAILABLE, STATUS_CONFIRMED } from '../../../../types/Order'
import { STATUS_DELIVERED } from '../../../../types/Order'

const GET_DATA = gql`
  query Counter($initialDate: String, $finalDate: String) {
    ordersAggs (
      size: 0,
      query: {
        bool: {
          must: [{
            terms: {
              status_translate_keyword: [
                "${STATUS_DELIVERED}"
              ]
            }
          }],
          filter: [{
            range: {
              created_at: {
                gte: $initialDate,
                lte: $finalDate
              }
            }
          }]
        }
      },
      aggs: {
        total: {
          sum: {
            field: "total"
          }
        }
      }
    ){
      aggregations
    }
  }
`

const GrossRevenue = (): JSX.Element => {
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true,
      variables: {
        initialDate: `${moment().clone().format('YYYY')}-01-01`,
        finalDate: `${moment().clone().format('YYYY')}-12-31`
      }
    }
  )

  useEffect(() => {
    getData()
  }, [])

  if (networkStatus === NetworkStatus.refetch) return <CardWidgetSkeleton />
  if (loading || !data) return <CardWidgetSkeleton />
  if (error) return <p>Error :(</p>

  return (
    <CardWidget title={`Faturamento total (dado fixo para o ano ${moment().format('y')})`} number={formatCurrency(data.ordersAggs.aggregations.total.value)} color={Colors.blue} />
  )
}

export default GrossRevenue
